export default __webpack_public_path__ + "static/media/arpeggio.c90b93d6.png";